export default __webpack_public_path__ + "static/media/pattern_roughness.ad874d01.jpg";